import GlassContainer from "@/shared/components/glasscontainer";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import icon from "@/assets/icons/brain.webp"


export interface AutomationsSidebarProps {
  total: number;
  totalNodes: number;
  loading: boolean;
}

export function AutomationsSidebar({ total, totalNodes, loading }: AutomationsSidebarProps) {
  const navigate = useNavigate();

  return (
    <aside className="w-80 shrink-0 px-8 pb-20 flex flex-col items-center justify-start overflow-y-auto min-h-screen">
      <img src={icon} className="size-68" />

      <h1 className="text-2xl font-bold tracking-tight text-foreground mb-3 text-center">
        Automatizaciones
      </h1>
      <p className="text-sm text-foreground/50 leading-relaxed text-center">
        Crea flujos de trabajo conectando nodos en un lienzo visual, similar a n8n, y pruébalos
        con el trigger manual.
      </p>

      <div className="mt-8 w-full space-y-3">
        <button
          onClick={() => navigate("/admin/automations/new")}
          className="w-full group cursor-pointer flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-accent text-white hover:bg-accent/90 transition-all duration-200 shadow-sm text-sm font-semibold"
        >
          <Plus className="size-4" />
          <span>Nueva automatización</span>
        </button>

        <GlassContainer className="flex items-center justify-between p-4">
          <p className="text-xs font-semibold text-foreground/60 uppercase tracking-widest">Total</p>
          <p className="text-3xl font-bold text-foreground">{loading ? "—" : total}</p>
        </GlassContainer>
        <GlassContainer className="flex items-center justify-between p-4">
          <p className="text-xs font-semibold text-foreground/60 uppercase tracking-widest">
            Nodos totales
          </p>
          <p className="text-3xl font-bold text-foreground">{loading ? "—" : totalNodes}</p>
        </GlassContainer>
      </div>
    </aside>
  );
}

